/* eslint-disable @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
import logoSvg from "assets/images/logo.svg";
import { RenderPage } from "components/Local/FooterNav/FooterNav";
import { i18n } from "localization/i18n";
import { convertUnits, ProductsValueType } from "utils/utils";

import { Document, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#fff",
    padding: "20px",
    width: "100%",
  },
  titleRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  titleAccent: {
    width: 4,
    height: 16,
    marginRight: 8,
    borderRadius: 2,
    backgroundColor: "#d07005",
  },
  title: {
    fontWeight: 700,
    fontSize: 16,
    textTransform: "uppercase",
    letterSpacing: 0.6,
    color: "#6a2200",
  },
  headerWrapper: {
    marginBottom: "10px",
    flexDirection: "row",
    width: "100%",
    borderRadius: "5",
    borderColor: "#f0d4bc",
    borderStyle: "solid",
    borderWidth: 1,
  },
  imageSection: {
    width: "200px",
    padding: 15,
    borderRightWidth: 1,
    borderColor: "#f0d4bc",
    borderStyle: "solid",
  },
  imageSectionTitle: {
    textTransform: "uppercase",
    color: "#6a2200",
    fontSize: 14,
    fontWeight: 700,
  },
  topInfoSectionWrap: {
    padding: 10,
    borderBottomWidth: 1,
    borderColor: "#f0d4bc",
    borderStyle: "solid",
    width: "100%",
  },
  topInfoSection: {
    flexDirection: "row",
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: 5,
  },
  topInfoSectionLabel: {
    fontWeight: 700,
    fontSize: 12,
    marginRight: 10,
    color: "#6a2200",
  },
  topInfoSectionData: {
    fontWeight: 400,
    fontSize: 12,
    color: "#4a3020",
  },
  bottomInfoSectionWrap: {
    padding: 10,
    width: "100%",
  },
  bottomInfoTitleWrap: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 10,
  },
  bottomInfoTitle: {
    color: "#6a2200",
    fontSize: 12,
    fontWeight: 700,
    width: "90px",
    paddingRight: 5,
  },
  infoWrap: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 5,
  },
  name: {
    fontSize: 12,
    width: "90px",
    paddingRight: 5,
    color: "#4a3020",
  },
  qty: {
    fontSize: 12,
    width: "90px",
    paddingRight: 5,
    color: "#4a3020",
  },
  volume: {
    fontSize: 12,
    width: "90px",
    paddingRight: 5,
    color: "#4a3020",
  },
  weight: {
    fontSize: 12,
    width: "90px",
    paddingRight: 5,
    color: "#4a3020",
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 8,
    backgroundColor: "#fdf1e6",
  },
  headingLeftImg: {
    width: "150px",
  },
});

interface PdfDocumentTypes {
  data: RenderPage[];
  options?: any;
  user: any;
}

const logoHideHost = ["gol.megasite.tech"];

export const PdfDocument = ({ data, options, user }: PdfDocumentTypes) => {
  const { t } = i18n;
  const getImageLink = (user: any) => {
    if (user?.logo) {
      switch (user.logo) {
        case "/design/images/avatars/0.svg":
        case "/design/images/avatars/1.svg":
        case "/design/images/avatars/2.svg":
          return logoSvg;
        default:
          return `https://www.qubictron.com${user.logo}`;
      }
    } else {
      return logoSvg;
    }
  };

  const isHideLogo = logoHideHost.includes(window.location.hostname);

  if (data) {
    return (
      <Document>
        {data.map(({ key, firstPageData, items }: RenderPage, i: number) => (
          <Page size="A4" style={styles.page} wrap={false} key={i}>
            <View>
              <View style={styles.wrapper} fixed>
                <View style={styles.titleRow}>
                  <View style={styles.titleAccent} />
                  <Text style={styles.title}>{t("Stuffing result")}</Text>
                </View>
                {!isHideLogo ? (
                  <View>
                    <Image style={styles.headingLeftImg} src={getImageLink(user)} />
                  </View>
                ) : null}
              </View>

              <View style={styles.headerWrapper} key={key} break wrap={false}>
                <View style={styles.imageSection}>
                  {firstPageData ? (
                    <>
                      <Text style={styles.imageSectionTitle}>{firstPageData.title}</Text>
                      <Image
                        source={firstPageData.image}
                        style={{ width: 175, marginLeft: "-15px", marginTop: "20px" }}
                      />
                      <Text style={styles.topInfoSectionLabel}>
                        {`${firstPageData.qty} unit${firstPageData.qty > 1 ? "s" : ""}`}
                      </Text>
                    </>
                  ) : (
                    <View style={{ width: 175 }} />
                  )}
                </View>
                <View>
                  {firstPageData ? (
                    <View style={styles.topInfoSectionWrap}>
                      <View style={styles.topInfoSection}>
                        <Text style={styles.topInfoSectionLabel}>{t("Total: ")}</Text>
                        <Text style={styles.topInfoSectionData}>
                          {firstPageData.itemQty} {t("packages")}
                        </Text>
                      </View>
                      <View style={styles.topInfoSection}>
                        <Text style={styles.topInfoSectionLabel}>{t("Cargo volume")}: </Text>
                        <Text style={styles.topInfoSectionData}>
                          {firstPageData?.cargoVolume} {firstPageData?.lengthUnits}3{" "}
                        </Text>
                      </View>
                      <View style={styles.topInfoSection}>
                        <Text style={styles.topInfoSectionLabel}>{t("Cargo weight")}: </Text>
                        {firstPageData ? (
                          <Text style={styles.topInfoSectionData}>
                            {firstPageData?.cargoWeight} {options.weightUnits}
                          </Text>
                        ) : (
                          <></>
                        )}
                      </View>
                    </View>
                  ) : (
                    <></>
                  )}

                  <View style={styles.bottomInfoSectionWrap}>
                    {firstPageData ? (
                      <View style={styles.bottomInfoTitleWrap}>
                        <Text style={{ ...styles.bottomInfoTitle, width: "140px" }}>{t("Name")}</Text>
                        <Text style={styles.bottomInfoTitle}>{t("Packages")}</Text>
                        <Text style={styles.bottomInfoTitle}>{t("Volume")}</Text>
                        <Text style={styles.bottomInfoTitle}>{t("Weight")}</Text>
                      </View>
                    ) : (
                      <></>
                    )}

                    {items.map((value: ProductsValueType, i: number) => (
                      <View key={value.name + i} style={styles.infoWrap}>
                        <Text style={{ ...styles.name, width: "140px" }}>{value.name}</Text>
                        <Text style={styles.qty}>{value.qty}</Text>
                        <Text style={styles.volume}>
                          {(options.lengthUnits === "mm" ? value.volume / 1000000000 : value.volume).toFixed(0)}{" "}
                          {options.lengthUnits === "mm" ? t("m") : options.lengthUnits}3{" "}
                        </Text>
                        <Text style={styles.weight}>
                          {convertUnits(value.weight, options.weightUnits).toFixed(0)} {options.weightUnits}
                        </Text>
                      </View>
                    ))}
                  </View>
                </View>
              </View>
            </View>
          </Page>
        ))}
      </Document>
    );
  } else {
    return null;
  }
};
